import GroupChangeFounderModalContainer from './GroupChangeFounderModal.container';
import GroupChangeFounderModal from './GroupChangeFounderModal';

import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import GroupChangeFounderModalV2 from '../GroupChangeFounderModal.gruser_backroom';

export default withFeatureBranch({
  gruser_backroom: GroupChangeFounderModalV2,
})(GroupChangeFounderModalContainer(GroupChangeFounderModal));
